export const LANG_EN_NAME = "en";

export const LANG_EN_TRANS = {
	"footer.copyright": `Impulse - Acquired by OPSWAT. All rights reserved. Impulse, SafeConnect, OPSWAT&reg;,<br>the Impulse logo and the
	OPSWAT logo are trademarks of OPSWAT, Inc.`,
	"download.title": "Download the SafeConnect SDP client",
	"account.delete.title": "DELETE your account?",
	"application.create.title": "Create a Protected Application",
	"application.edit.title": "Update a Protected Application",
	"application.form.label.name": "Application Name",
	"application.form.label.web": "Web Application",
	"application.form.label.network": "Other (e.g.: SSH, RDP, etc.)",
	"applications.add.text": "Add",
	"applications.header.title": "Applications",
	"applications.info.block.1": `A protected application contains the definition of how to reach that application. An application can then
		be assigned to specific user groups as needed. Only members of the associated group will be able to request access to the
		application`,
	"applications.webapps": "Web Applications",
	"applications.otherapps": "Other Applications",
	"applications.info.maximum.applications.created": "You've allocated the maximum number of applications permitted.",
	"applications.label.application": "Application",
	"applications.label.ip": "Address",
	"applications.label.example": "Examples:",
	"applications.label.portNumber": "Port",
	"applications.label.portNumbers": "Port(s)",
	"applications.label.name": "Name",
	"applications.label.proto": "Protocol",
	"applications.label.requiresKeepalive": "Port Keepalive",
	"applications.label.roles": "Groups",
	"applications.label.webUrl": "Web URL",
	"applications.label.keepAlive": "Permit New Connections",
	"applications.label.image": "Image",
	"error.form.ip": "You must enter a valid IP address",
	"error.form.ipdomain": "You must enter a domain name, IP address, CIDR specification, or a range of IP addresses",
	"error.form.portNumber": "Port must be between 1 and 65535.",
	"error.form.name": "You must enter a name",
	"error.form.webUrl": "You must enter a valid web URL",
	"error.form.name.duplicate": "An application with this name already exists",
	"error.form.passwordDoNotMatch": "Passwords do not match",
	"error.form.urlPrefix": "You must enter a URL Prefix",
	"error.form.duplicate.resource": `The combination of "IP or Hostname", "Port", and "URL Suffix" conflicts with another resource. Edit this
		resource to avoid creating a duplicate.`,
	"error.form.port.same": "Ports must be different",
	"error.message.accessCode": "You must enter an access code.",
	"error.meesage.account": "You must enter an site name.",
	"error.message.codeMisMatch": "Invalid registration code. Check your email again for the correct registration code.",
	"error.message.invalidEmailOrPassword": "Please try again. The email address or password you provided is not correct.",
	"error.message.currentPassword": "You must enter your current password.",
	"error.message.passwordLength": "Your password must be at least eight (8) characters.",
	"error.message.email": "You must enter a valid Email Address.",
	"error.message.expiredCode": `This account is either already confirmed, or the registration code is expired. Try logging in, or
		registering a new account.`,
	"error.message.firstname": "You must enter a first name.",
	"error.message.lastname": "You must enter a last name.",
	"error.message.password": "You must enter a password.",
	"error.message.passwordMatch": "Passwords do not match.",
	"error.message.totp": "You must enter a valid code.",
	"error.message.deviceLabel": "You must enter a device label.",
	"error.message.userNotFound": "No account is registered with this email address. Register a new account.",
	"error.message.wrongCode": "Activation Code was not accepted.",
	"error.message.confirmationEmail": "An error occurred sending the confirmation email.",
	"error.message.registration.accountBeingDeleted": "An account with this name is being deleted. Please try again shortly.",
	"error.message.registration.accountAlreadyExists": "An account with this name already exists.",
	"error.message.registration.emailAlreadyRegistered": "This email address is already registered.",
	"error.totp.codeMismatch": "The code you entered is incorrect. Please try again.",
	"footer.rights": "ALL RIGHTS RESERVED",
	"forgotpassword.title": "Forgot Password",
	"forgotpassword.description": "Please enter your email address to start password recovery",
	"form.label.accessCode": "Access Code",
	"form.label.back": "Back",
	"form.label.comment": "Comment",
	"form.label.company": "Company",
	"form.label.confirmNewPassword": "Confirm New Password",
	"form.label.confirmPassword": "Confirm Password",
	"form.label.continue": "Continue",
	"form.label.country": "country",
	"form.label.currentPassword": "Current Password",
	"form.label.email": "Email",
	"form.label.firstname": "First Name",
	"form.label.firstLastname": "First and Last Name",
	"form.label.lastname": "Last Name",
	"form.label.newPassword": "New Password",
	"form.label.password": "Password",
	"form.label.phone": "Phone Number",
	"form.label.resendConfirmation": "Resend Email",
	"form.label.register": "Register",
	"form.label.resetPassword": "Reset Password",
	"form.label.signIn": "Sign In",
	"form.label.stateProvince": "State/Province",
	"form.label.isAdmin": "Admin",
	"form.label.totp": "MFA Code",
	"forcePasswordChange.button.text": "Set Password",
	"forcePasswordChange.description": "To get started, please provide a password",
	"forgotpassword.change": "Please enter a new password",
	"forgotpassword.verify.1": `An email will be sent to '[[email]]'. If you do not receive the email in a timely manner, please check
		your spam folder and/or verify that the spelling of the email address is correct.`,
	"forgotpassword.verify.2": "Please check your email for further instructions.",
	"forgotpassword.verify.3": "The Forgot Password link will be valid for a limited time.",
	"header.item.administration": "Administration",
	"header.item.deleteAccount": "Delete Account",
	"header.item.dashboard": "Dashboard",
	"header.item.settings": "User Settings",
	"header.item.signOut": "Sign Out",
	"header.sub.title": "Cloud Portal",
	"header.item.attribution": "Attribution",
	"home.browser.title": "Start",
	"home.link.applications": "Applications: The applications you are trying to protect",
	"home.link.users": "Users: Individual or groups of users that have access to specified applications",
	"login.resetPasswordFailed": "Invalid new password. Passwords should be at least eight (8) characters.",
	"login.mfaRequired": "Your account requires multi-factor authentication.",
	"message.account.verified": "Your account has been verified. Please enter your password and sign in to continue",
	"message.account.verify": "Thank you for your request, you will receive an email shortly to verify your account",
	"message.account.isNotConfirmed": "Your account is pending confirmation.",
	"message.account.resendConfirmation": "Resend confirmation email",
	"message.account.confirmationResent": "A confirmation link has been sent to the email associated with this account",
	"message.account.invalidCode": `The registration confirmation code provided wasn't valid.
		Would you like to resend the confirmation email?`,
	"message.password.reset.successful": "Password reset successful",
	"message.password.signin.new": "Please sign in with your new password.",
	"mfa.cantaccess.title": "Can't access your account?",
	"registration.create.title": "Create an Account",
	"registration.form.account": "Youraccount",
	"registration.form.account.info": "Account Name",
	"registration.form.back.signIn": "Continue to Sign In",
	"registration.form.needCode": "Need an Activation Code",
	"registration.policy.1": "I have read and agree to the",
	"registration.policy.2": "Privacy Policy",
	"registration.signIn.title": "Sign In",
	"requestCode.description": "Enter your information to request an activation code for",
	"requestCode.send": "Send Request",
	"resetpassword.description": `Choose a new password for this user account. This password will replace the old one; everything else
		about this user account will remain unchanged`,
	"resetpassword.success": `Your password has been reset. You will be required to use your new password the next time you log in.`,
	"resetpassword.title": "Reset Password",
	"sdp.label.add": "Add",
	"sdp.label.create": "Create",
	"sdp.label.create.add.new": "Create & New",
	"sdp.label.update": "Update",
	"sdp.label.cancel": "Cancel",
	"sdp.label.previous": "Previous",
	"sdp.label.next": "Next",
	"sdp.label.done": "Done",
	"sdp.label.delete": "Delete",
	"sdp.label.edit": "Edit",
	"sdp.label.send": "Send",
	"sdp.label.label": "Label",
	"sdp.label.clickhere": "Click here",
	"sdp.label.closeWizard": "Finish",
	"sdp.label.ip": "IP Address",
	"sdp.label.registrationDate": "Registration Date",
	"sdp.label.status": "Status",
	"sdp.label.activate": "Activate",
	"sdp.label.deactivate": "Deactivate",
	"sdp.label.accept": "Accept",
	"sdp.label.port": "UDP Port(s)",
	"sdp.label.host": "Host(s)",
	"sdp.user.groups": "User Groups",
	"sdp.welcome.to": "Welcome to ",
	"settings.title": "User Settings",
	"settings.mfa.header": "Multi-factor Authentication (MFA)",
	"settings.mfa.enabled": "MFA has been enabled.",
	"settings.mfa.disabled": "MFA has been disabled.",
	"settings.mfa.description": "Protect your account using an authenticator app on your device every time you log in.",
	"settings.mfa.instructions": "1. Scan the QR code in your favorite authenticator app (e.g. Google Authenticator or Authy).",
	"settings.mfa.instructions2": "2. Enter the code shown in the authenticator app.",
	"settings.mfa.setupButton.text": "Setup",
	"settings.mfa.requestKeyButton.text": "Request Key",
	"settings.mfa.disableButton.text": "Disable",
	"settings.mfa.completeSetupButton.text": "Complete setup",
	"settings.mfa.secretKeyLabel": "Secret key",
	"settings.mfa.totpCodeInput.text": "Code",
	"settings.mfa.deviceNameInput.text": "Device label, e.g. \"My iPhone\"",
	"settings.mfa.deviceNameLabel": "Please enter a label to identify your new authentication device:",
	"settings.mfa.disableMfaDescription": "MFA is enabled. Check your authenticator app for",
	"summary.header.title": "Summary",
	"tagger.placeholder": "Groups",
	"user.create.title": "Create a User",
	"user.edit.title": "Update a User",
	"users.header.title": "Users",
	"userResourceList.header.title": "My Protected Applications",
	"userResourceList.noResources": `There are no resources that you have been provided access to. Contact your account administrator for
		access to protected resources.`,
	// 0710 new texts
	"imageManager.heading.title": "File size and dimensions",
	"imageManager.": "Upload an image",
	"imageManager.selector.button": "Choose File",
	"imageManager.file.uploaded": "has been uploaded.",
	"message.forgotpassword.reset": "Your password has been changed. Please sign in with your new password",
	"user.edit.created": "User [[username]] has been created and an email invitation has been sent",
	// 0713
	"error.message.password.length.min": "Password must have a length greater than or equal to 6",
	"error.message.account.required": "Account Name is required",
	// 0718 updates to existing
	"registration.form.account.tooltip": `Must be at least 5 characters, numbers and letters only. Once your account is
		provisioned, the account name cannot be changed`,
	"account.delete.confirmation": `This action CANNOT be undone and will permanently delete your account and all associated
		settings. Please type your account name \"[[accountName]]\" to confirm deletion of your account.`,
	"account.delete.placeholder": "Account Name",
	// 0720
	"assignApplications.edit.tooltip": "Add/Remove assignments for applications",
	"assignApplications.clear.tooltip": "Remove all assignments from this application. The application will no  longer be accessible",
	"assignApplications.grid.user-group": "Users/SAML Groups",
	"roles.noRoles": "To assign groups, please click the edit button",
	"generic.table.tags.noTags": "To assign groups, please click the edit button",
	"assignApplications.delete.dialog.message": "Are you sure you want to remove all groups from \"[[applicationName]]\"?",
	"assignApplications.delete.dialog.title": "Delete Application Access Groups/Users",
	"assignApplications.update.success.message.noRoles": `All groups from \"[[applicationName]]\" have been removed.
		This applicaiton is no longer accessible`,
	"assignApplications.table.placeholder": "No applications have been assigned policies.",
	// 0727
	"applications.delete.dialog.message": "Are you sure you want to delete '[[applicationName]]'?",
	"applications.delete.dialog.title": "Delete Application",
	"users.delete.dialog.message": "Are you sure you want to delete '[[email]]'?",
	"users.delete.dialog.message.self": "Are you sure you want to delete <b>yourself</b>?",
	"users.delete.dialog.title": "Delete User",
	"users.delete.dialog.title.admin": "Delete Administrator",
	"users.delete.dialog.title.self": "Delete Yourself",
	"users.delete.dialog.confirmation": "Please type the administrator's email to confirm the deletion.",
	"users.delete.dialog.confirmation.self": "Please type your email to confirm the deletion.",
	"users.sendEmail.dialog.message": "Are you sure you want to resend activation code to '[[email]]'?",
	"users.sendEmail.dialog.title": "Resend Invitation Code",
	"users.sendEmail.success.message": "Invitation resent to \"[[email]]\"",
	"assignments.update.success.message.roles": "\"[[applicationName]]\" has been updated",
	// messages the backend might send us
	"error.message.deleteAccount.alreadyBeingDeleted": "This ccount is already being deleted.",
	"error.message.deleteAccount.genericError": "An error occurred deleting this account.",
	"error.message.application.noPortsAvailable": `All of the available container ports are in use, so no more resources can be
		created.`,
	"error.message.application.duplicateName": "An application with name \"[[name]]\" already exists.",
	"error.message.application.duplicateData": `A resource with IP \"[[ip]]\", port \"[[port]]\", and URL suffix \"[[urlSuffix]]\" already
		exists`,
	"error.message.deleteApplication.notFound": "No application with name \"[[name]]\".",
	"error.message.roles.duplicateName": "A role already exists with name \"[[name]]\".",
	"error.message.deleteRole.notFound": "No role with name \"[[name]]\".",
	"error.message.user.duplicateName": "A user with email \"[[name]]\" already exists.",
	"error.message.deleteUser.notFound": "No user with email \"[[name]]\".",
	"error.access.genericError": "An error occurred requesting access to this application.",
	"error.access.notAuthorized": "User \"[[caller]]\" is not authorized for access to application \"[[resourceName]]\".",
	"error.access.notFound": "No application found with name \"[[resourceName]]\".",
	"error.accountNotFound": "No such account \"[[account]]\".",
	"error.lookupUserNotFound": "User with email \"[[name]]\" not found.",
	"error.callerNotFound": "User with email \"[[caller]]\" not found on account \"[[account]]\".",
	"error.userNotFound": "User with with email \"[[name]]\" not found on account \"[[account]]\".",
	"error.roleNotFound": "Role with name \"[[roleName]]\" not found on account \"[[account]]\".",
	"error.applicationNotFound": "Application with name \"[[applicationName]]\" not found on account \"[[account]]\".",
	"error.environment": "An unexpected error occurred handling this request.",
	"error.gatewayContainerNotFound": "An unexpected error occurred handling this request.",
	"error.gatewayContainerInvalid": "An unexpected error occurred handling this request.",
	"error.badRequestParameters": "An unexpected error occurred handling this request.",
	"error.resend.fail": "An unexpected error occurred, Unable to resend invitation",
	// 073117
	"groups.tagger.placeholder": "+ Group",
	"groups.tagger.secondaryPlaceholder": "Add a new Group",
	"home.link.summary": "Summary: View all applications and user groups",
	"tag.placeholder.label.group": "[[group]] (New Group)",
	"application.wizard.ports.helpText": `
		Are additional ports required to use your application? Ensure that all ports needed to access your application are entered below.
		Many web applications will require this behavior.`,
	"application.wizard.title.create": "Create a Protected Application",
	"application.wizard.title.update": "Update a Protected Application",
	"application.wizard.selectType.type.message": "What type of application would you like to protect?",
	"application.wizard.summary.title": "Review Protected Application",
	"application.wizard.web.title": "Create a Protected Web Application",
	"application.wizard.web.form.label.web": "Application URL",
	"applications.title": "Define Protected Applications",
	"users.title": "Define Users and Groups",
	// 081717
	"form.label.identityProvider": "Identity Provider",
	"form.label.attributes": "Group Attributes",
	"form.label.groups": "Group Values",
	"error.account.delete": "Account Name must be entered to delete the account.",
	// 081817
	"error.form.name.pattern": "Application Name must be alphanumeric characters only.",
	"imageManager.selector.button.default": "Reset Image",
	"user.wizard.userEdit.title.create": "Create User",
	"user.wizard.userEdit.title.update": "Update User",
	"user.wizard.groupsToUsers.createGroup": "Add",
	"user.wizard.groupsToUsers.selectPlaceholder": "No groups selected",
	"sdp.label.policy": "Policy",
	"sdp.label.gateway": "SDP Gateway",
	// 082117
	"home.link.rules": "Policies: The conditions required for Users to access an Application",
	"assignApplications.title": "Define Policies",
	"assignApplications.header.title": "Policies",
	"application.wizard.selectImage.description": `Select an image that will be displayed to end users to help
		identify the protected application.`,
	"application.wizard.selectType.name.message": `What is the name of your protected application?
		This will be the name displayed to the end users.`,
	"sdp.done.descriptive": "Click \"Done\" to go to your Protected Applications.",
	"application.wizard.web.settings.message": `The option below is needed for applications that periodically require
		a new connection.`,
	"applications.label.requiresKeepalive.true": "Permit application to periodically establish new connections.",
	"applications.label.requiresKeepalive.false": "Permit only the initial connection to the application.",
	"applications.port.add.text": "Add Port",
	"application.wizard.networkService.urlDescription": `Before a client application will automatically launch, a URL
		handler must be set up on the end user machine for each protocol used. More information on
		configuring URL handlers for common protocols can be found in our knowledgebase.`,
	"user.samlGrid.title": "SAML",
	"assignApplications.update.success.message.roles": `\"[[applicationName]]\" Policies have been updated.`,
	"imageManager.file.info": "*Image will be scaled to 160x60 pixels.",
	"policy.wizard.applicationSelect.title": "Assign Policies to an Application",
	"policy.wizard.applicationSelect.info": "Select an application to start assigning policies.",
	"policy.wizard.applicationSelect.searchPlaceholder": "Search for Applications",
	// 082217
	"policies.info": `Policies determine the requirements that must be met to access an application.`,
	"user.info.block.1": `Create internal users to access your protected applications.`,
	"user.saml.block.1": `Configure SAML for authentication and authorization.`,
	"home.info.block.1": ` is an easy to deploy, cloud-based Software Defined Perimeter, that provides advanced protection for your
		resources by securing access to your protected applications.`,
	"home.info.block.2": `Click "Next" to begin!`,
	"home.area3.header": "Administration",
	"home.link.admin": "Manage Sessions, Users, Applications, and Policies.",
	"summary.description": `This is a summary of the defined applications and the requirements to access those applications. Before
		your Software Define Perimeter setup is complete, ensure that access to your protected applications is only permitted
		from the SDP gateway IP address`,
	"summary.cloud.gateway": "Cloud Gateway",
	"home.link.policies": "Policies: Determine the requirements that must be met to access an application",
	"user.wizard.groupsToUsers.title": "Assign Groups to Users",
	"user.wizard.groupsToUsers.optionsHeader": "Available Groups",
	"user.wizard.groupsToUsers.selectedHeader": "Selected Groups",
	"user.wizard.groupsToUsers.searchPlaceholder": "Search for Groups",
	"user.wizard.groupsToUsers.createGroupPlaceholder": "Create New Group",
	"application.wizard.web.url.message": "What is the full URL of the web application you would like to protect?",
	"user.userGrid.title": "Users",
	"password.strength.label": "Password strength",
	"forgotPassword.attemptLimitExceeded": `You have exceeded the number of password reset attempts. Please wait a short while before
		trying again.`,
	"forgotPassword.genericError": "An error occurred trying to reset your password. Please try again.",
	"resetPassword.attemptLimitExceeded": `You have exceeded the number of password reset attempts. Please wait a short while before
		trying again.`,
	"resetPassword.genericError": "An error occurred trying to reset your password. Please try again.",
	// 0831
	"saml.wizard.selectIdp.title": "Add a SAML Identity Provider",
	"saml.wizard.upload.description": `Download the metadata from \"[[samlIdp1]]\" and upload it to [[applicationTitle]]. This file
		 will let us trust \"[[samlIdp2]]\" to authenticate your users.`,
	"saml.wizard.upload.upload": "Add a SAML Identity Provider",
	"saml.wizard.selectIdp.select.placeholder": "Select Identity Provider",
	"saml.wizard.download.description": `Enter the following [[applicationTitle]] service provider information into \"[[samlIdp]]\"
		or download the metadata and upload it.`,
	"saml.label.entityId": "EntityID",
	"saml.label.acsUrl": "ACS URL",
	"saml.label.loginUrl": "Login URL",
	"saml.wizard.download.metadata": "IdP metadata:",
	"sdp.label.or": "OR",
	"sdp.label.setup": "Setup",
	"sdp.label.download": "Download",
	"saml.wizard.download.ca.cert": "Download the CA certificate:",
	"saml.wizard.download.title": "Provide SP details to SAML Identity Provider",
	"sdp.label.expires": "Expires",
	"saml.wizard.username.title": "Define the \"[[samlIdp]]\" group attributes",
	"saml.wizard.username.description": `Map IdP attributes for groups. Group values will become available to assign to
		users in the users and group creation section.`,
	"saml.wizard.username.label.attribute.name": "Username Attribute",
	"saml.wizard.username.label.attribute.format": "Attribute Format",
	"saml.wizard.username.group.description": "Attributes to map to User Groups",
	"saml.wizard.username.username.description": "Attribute to map to UserName",
	"saml.wizard.username.label.attribute.group": "Group Attribute",
	"saml.delete.idp.dialog.message": "Are you sure you want to delete '[[idpName]]'?",
	"saml.wizard.upload.metadata.update": "*You already have a metadata on file. If you would like to change it, please upload another one.",
	"error.form.usernameAttribute": "Username Attribute is required.",
	"saml.delete.idp.dialog.title": "Delete Identity Provider",
	"saml.delete.idp.success": "Identity Provider '[[idpName]]' has been deleted.",
	"saml.update.idp.success": "Identity Provider '[[idpName]]' has been updated.",
	"saml.create.idp.success": "Identity Provider '[[idpName]]' has been created.",
	"saml.wizard.upload.title": "Upload SAML Identity Provider metadata",
	"saml.wizard.summary.metadata.status": "Loaded",
	"saml.wizard.summary.description": `Please verify that all the information is correct. Once you are satisfied,
		click '[[action]]' to finish.`,
	"form.label.usernameAttribute": "Username Attribute",
	"saml.wizard.select.idp.name.undefined": "Please select an Identity Provider to continue.",
	"sdp.label.option": "Option",
	"saml.wizard.selectIdp.description": `Using a SAML 2.0 Identity Provider (IdP) allows administrators to consolidate identity information
	outside of individual applications. Certificates are used to establish a trust between us and the IdP. Once this is configured, instead
	of authentication at our log in page, users will be redirected to their IdP where they can authenticate, or, if they have already done
	so, be redirected back to us for a single sign-on experience.`,
	"sdp.label.name": "Name",
	"sdp.label.metadata": "Metadata",
	"saml.wizard.summary.title": "Review details for Identity Provider",
	"login.saml.heading": "or login with",
	"user.wizard.isAdmin": "Allow user to access this administrative portal",
	"user.wizard.edit.description": `Administer the set of users that will, where policy permits, have access to protected applications
	and to this portal.`,
	"user.wizard.groups.description": "Assign groups to users to allow them to access applications that are also assigned to that group.",
	"application.wizard.selectType.description": `Name your application and select the type. If it is a simple web app select Web Application.
		If your application has more specific values, select Other.`,
	"applicaiton.wizard.webUrl.description": "Specify the URL to be used for this application.",
	"applicaiton.wizard.summary.description.create": `Review your selection. When you are ready click the Create button to save your
		applicaiton.`,
	"applicaiton.wizard.summary.description.update": `Review your selection. When you are ready click the Update button to save your
		applicaiton.`,
	"application.wizard.networkAdvanced.description": "Here you can select a prefix (rdp, telnet, etc) and options for yoru application.",
	"application.wizard.networkService.description": [
		"The address used to access your application. ",
		"This can be a domain name, IP address, CIDR specification, or a range of IP addresses."
	].join(""),
	"sdp.label.step": "Step",
	"saml.wizard.upload.step1": "Download the metadata file from your IdP.",
	"saml.wizard.upload.step2": "Select the metadata file from your machine and upload it.",
	"saml.wizard.upload.another": "Upload another file",
	"saml.wizard.upload.use.existing": "Use existing",
	"saml.idp.create.metadata.failed": "An error occurred processing the metadata for this Identity Provider.",
	"saml.idp.create.save.failed": "An error occurred saving this Identity Provider.",
	"error.form.groupAttribute": "You must provide a value for the attribute.",
	"client-download.header.title": "Client",
	"client-download.page.title": "SDP Client",
	"client-download.description":
		"In order to access protected applications, SDP requires a client to be downloaded and installed.",
	"client-download.download.line": "to download the SDP Client.",
	"client-download.invite.line.email": "Email an invitation to your users",
	"client-download.invite.line.copy": "or copy the email template to your clipboard",
	"home.link.download": "Download SDP Client",
	"home.link.invite-download": "Invite users to download the SDP Client",
	"home.area1.header": "Configure Applications, Users, and Policies",
	"home.area2.header": "Download client and invite users",
	"download.email.template.subject": "You have been invited to use SafeConnect SDP",
	"sdp.label.close": "Close",
	"sdp.label.copy": "Copy to Clipboard",
	// this is an email template in a textarea, all formatting is preserved, you cannot tab in here or it will be visible in the html
	"download.email.template.body": `Hello,\n\r
Your SafeConnect SDP Admin has invited you to use SafeConnect SDP within your organization.\n\r
To get started, <a href="[[downloadUrl]]">download the SDP client</a>.\n\r
You'll need to provide this account name before you can login and begin accessing resources:
Account Name: [[accountName]]\n\r
For any questions you may have, or for technical assistance, please contact your site administrator.\n\r
Thanks!`,
	"download.description": `The SDP Client plays a key role in protecting your applications and data. It must be installed to access
	protected applications.  Download the correct platfrom installer based on your device.`,
	"sdp.label.email.template.tooltip": "Open Email client",
	"application.port.add.tooltip": "Add another port",
	"application.port.remove.tooltip": "Remove this port",
	"application.port.icmp.toggle": "Allow ICMP traffic",
	"application.port.icmp.hover": "Allow ICMP traffic (e.g. ping) to this application",
	"access.title": "Access Protected Applications",
	"access.wizard.title": "Access",
	"access.section.1.header": "Experience protection",
	"access.section.1.body": `The Example application is pre-loaded to demonstrate a protected application. Before installing the client,
	try accessing the example web application by clicking the button on the right. Observe that the protected web application is unreachable.`,
	"access.section.1.url.text": "Example web application",
	"access.section.2.header": "Access the protected application",
	"access.section.2.body": `Download the SafeConnect SDP client by clicking the button on the right. Once the client has established a
	connection, the protected web application can now be accessed by refreshing the page.`,
	"access.section.2.download.text": "Download client",
	"access.section.3.header": "Invite others to access the protected application",
	"access.section.3.body": `Before inviting others to access protected applications, you must first grant them access using this wizard.
	Use the buttons on the right to send email invitations.`,
	"access.section.3.invite.text": "Email invitation",
	"access.section.3.copy.text": "Copy email template",
	"dashboard.title": "Dashboard",
	"devices.title": "Devices",
	"device.name": "Name",
	"device.type": "Type",
	"device.contactTime": "Access Time",
	"devices.globalSearch": "Global Search",
	"dashboard.home": "Home",
	"dashboard.devices": "Devices",
	"dashboard.users": "Users",
	"dashboard.applications": "Applications",
	"dashboard.sessions": "Sessions",
	"dashboard.wizard": "Wizard",
	"dashboard.policies": "Policies",
	"sessions.title": "Sessions",
	"session.startTime": "Start Time",
	"session.endTime": "End Time",
	"session.deviceName": "Device Name",
	"session.gatewayType": "Gateway Name",
	"session.deviceType": "Device Type",
	"session.userName": "User Name",
	"session.ip": "IP",
	"session.macAddress": "MAC Address",
	"generic.dateTime.dropdown.placeholder": "Select Date",
	"session.noResultsFound": "There are no sessions for this account.",
	"generic.totalRecords": "[[start]] - [[end]] of [[total]] [[tableName]]",
	"session.clientVersion": "Version",
	"sdp.label.active": "Active",
	"sdp.label.all": "All",
	"sdp.label.inactive": "Inactive",
	"sessions.info.block.1": "View information about your SDP activity like who, when, what devices have been active recently.",
	"session.refresh.tooltip": "Refresh Sessions",
	"sdp.label.submit": "Submit",
	"generic.dateTime.dropdown.reset.tooltip": "Reset DateTime Filter",
	"error.api.generic.message": `Oops! There was an issue trying to process your request. If the problem persists,
		contact support at `,
	"error.retry.message": "Try Again",
	"generic.deviceType.error.notfound": "Error reporting Device Type",
	"generic.no.records": "No records found",
	"gateway.accept.icon.tooltip": "This will activate this pending Gateway. If another Gateway is active, it will be set to inactive.",
	"gateway.delete.icon.tooltip": "Delete Gateway",
	"gateways.title": "Gateways",
	"gateway.description.cloud": `The cloud-hosted gateway is pre-loaded in the AWS cloud. To use this gateway, in your firewall or SaaS
		application, only permit traffic from the IP address shown above.`,
	"gateway.description.private.enabled": "Private gateways can be deployed either on-premise or in your cloud provider network.",
	"gateway.description.private.disabled": `Private gateway support isn't enabled for this account. Contact
		<a href="mailto:sales@impulse.com">sales@impulse.com</a> to enable this feature.`,
	"gateways.info.block.1": "SDP Gateways sit inline between the user and application, both to hide the application and control access.",
	"gateway.has.pending.toolTip": "You have a pending Gateway, to Activate or remove it, click the Gateways menu item.",
	"gateway.download.title": "SDP Gateway Download",
	"gateway.download.info.block.1": "Download the latest Gateway to enable private access to your protected assets.",
	"gateway.download.step.1.chip": "Download and Install",
	"gateway.download.step.1": "Click the button above to download the SDP Client and complete installation.",
	"gateway.download.step.2.chip": "Register Gateway",
	"gateway.download.step.2": `Log in to the Private Gateway using the following credentials to configure it. Enter your Account Name and
		return to this application. Go to the Gateways page and enable the Private Gateway.<br>
		<p>
			Username: admin<br>
			Password: admin
		</p>`,
	"gateway.download.step.3.chip": "Update Inbound Firewall",
	"gateway.download.step.3": `The Private Gateway receives UDP traffic on ports 30000 and 30001.
		Forward incoming traffic on the configured external ports to the Private Gateway to allow clients outside your network to connect.`,
	"gateway.download.step.4.chip": "Finish Activation",
	"gateway.download.step.4": "Your Gateway is now available to use.",
	"gateway.download.step.4.link": "Activate Gateway.",
	"gateways.pending.title": "Pending Gateways",
	"gateway.delete.dialog.title": "Delete Gateway",
	"gateway.delete.dialog.message": "Are you sure you want to delete '[[label]]'?",
	"gateway.edit.title": "Update Gateway",
	"gateway.edit.description": "You can change the Label or the Host that this gateway references.",
	"gateway.edit.advanced": "Advanced",
	"gateway.edit.name.description": "You can change the Label that this gateway references.",
	"gateway.edit.ipPorts.description": `Customize the IP address(es) or provide alternative external ports. <br>
	NOTE: Both ports will need to be forwarded in your firewall.`,
	"gateway.edit.dns.description": `With Custom DNS, DNS is queried from the Private Gateway's network using the DNS servers specified below.
		When disabled, the DNS is done from the client device using the device's DNS configuration.`,
	"gateway.edit.publicIp": "Public IP Address",
	"gateway.edit.privateIp": "Private IP Address",
	"gateway.edit.external.tunnel.port": "External Tunnel Port",
	"gateway.edit.internal.tunnel.port": "Internal Tunnel Port",
	"gateway.edit.external.security.port": "External Security Port",
	"gateway.edit.internal.security.port": "Internal Security Port",


	"gateway.activate.dialog.title": "Activate Gateway",
	"gateway.deactivate.dialog.title": "Deactivate Gateway",
	"gateway.activate.dialog.message": `Are you sure you want to activate '[[label]]'? <br><br>
		This will take affect immediately. New client connections will be distributed among all active gateways.`,
	"gateway.deactivate.dialog.message": `Are you sure you want to deactivate '[[label]]'? <br><br>
		This will take affect immediately, preventing new client connections to this gateway. While the gateway remains online, existing
		connections will continue uninterrupted. New client connections will be distributed among all remaining active gateways.`,
	"sdp.gateway.private.radio.text": "Private Gateway",
	"sdp.gateway.cloud.radio.text": "Cloud Gateway",
	"gateways.download.name": "Download the Private Gateway",
	"gateways.download.text": "to get started protecting on premise or private cloud applications.",
	"gateway.version.new": "Newer version available",
	"gateway.version.download": "Download new gateway version",
	"error.message.host.required": "Host is required.",
	"error.message.label.required": "Label is required.",
	"error.message.saml-group.required": "SAML Group is required.",
	"error.message.provider-id.required": "Provider is required.",
	"error.message.label.invalid": "Label can only contain letters, numbers, spaces, dashes, and underscores.",
	"error.form.ipdomain.host": "You must enter a domain name or IP address",
	"sdp.beforeunload.message": "Changes you made may not be saved.",
	"gateway.no.active.gateway.message": `You must select a Private Gateway before you leave this area. If you do not, the Cloud Gateway
	will be used.`,
	"sdp.gateway.activated": "The '[[label]]' Gateway has been activated.",
	"sdp.gateway.deactivated": "The '[[label]]' Gateway has been deactivated.",
	"sdp.error.unknown": "An Unknown error occurred.",
	"sdp.gateway.update.success": "'[[label]]' Gateway has been updated.",
	"sdp.gateway.delete.success": "'[[label]]' Gateway has been deleted.",
	"sdp.gateway.accept.success": "'[[label]]' Gateway has been accepted.",
	"gateways.refresh.tooltip": "Refresh Gateways",
	"gateway.download.whats.new": "What's New",
	"gateway.download.version": "Version",
	"gateway.download.error.noManifest": `Oops! We could not find any files for download. Please refresh this page. If the problem
	persists, contact support at `,
	"account.info.error": "Failed to retrieve account information.",
	"sdp.gateway.customDNS": "Use custom DNS server(s)",
	"sdp.gateway.customDNSSuffix": "Use domain suffix",
	"error.message.dns.required": "A DNS server IP is required.",
	"error.message.dns.invalid": "A DNS server must be a valid IP address.",
	"error.message.dns.same": "IP addresses must be different.",
	"error.message.dns.suffix.required": "A domain suffix is required.",
	"error.message.dns.suffix.invalid": "A domain suffix must be part of a valid DNS name.",
	"form.label.dns1": "Primary DNS server",
	"form.label.dns2": "Secondary DNS server",
	"form.label.dnsSuffix": "DNS Suffix",
	"privategateway.dns.disabled": "Custom DNS is disabled",
	"privategateway.dns.label": "Custom DNS",
	"privategateway.dns.help": `Setting a DNS server for your Private Gateway allows clients connected to this gateway to use this server
	for DNS resolution instead of their system's default. If you use a private DNS server for internal resources, this will allow  users
	to continue to reach those resources by name when connected remotely.`,
	"privategateway.dns.suffix.help": `Clients will append this value to host names when resolving them. This allows clients to resolve
	names provided as just a subdomain rather than a fully qualified domain name.`,
	"privategateway.dns1.invalid": "Invalid Primary DNS server",
	"privategateway.dns2.invalid": "Invalid Secondary DNS server",
	"privategateway.dns.required": "A Primary DNS server is required when custom DNS is enabled",
	"gateway.state.error.message": `Timed out waiting for gateway to be provisioned. You can try again by re-deploying the gateway VM, if
		errors persist please contact support.`,
	"user.wizard.hide.wizard": "Do not show the wizard again",
	"dashboard.clients": "Client Access",
	"client.access.title": "Client Access",
	"client.access.section.1.header": "Download SDP Client",
	"client.access.section.1.body": `Download the SafeConnect SDP client by clicking the button on the right.`,
	"client.access.section.2.header": "Invite others",
	"client.access.section.2.body": `To invite others, add them to <a href="/administration/users">Users</a> to grant access. Then, use
	 the buttons on the right to send e-mail invitations.`,
	"client.access.section.1.download.text": "Download client",
	"client.access.section.2.invite.text": "Email invitation",
	"client.access.section.2.copy.text": "Copy email template",
	"copy.email.template.toastr": "The email template body has been copied to the clipboard",
	"heartbeat.tooltip.good": "The private gateway is active and healthy.",
	"heartbeat.tooltip.warning": "The private gateway hasn't sent an update in some time. It may be experiencing an issue.",
	"heartbeat.tooltip.bad": "The private gateway isn't active, and may have experienced a problem. Try restarting the private gateway.",
	"heartbeat.text.never": "No Contact",
	"heartbeat.text.old": "No health data available for this gateway version.",
	"error.form.gatewayVersionOld": "One or more Active Gateways are too old to support this action.",
	"error.form.minGtMaxPort": "Port range must be 'min'-'max'.",
	"privategateway.form.activetitle": "Active Gateways",
	"privategateway.form.activesubtitle": `This is the pool of available gateways.
		Clients will be load balanced across this pool, ignoring any gateways not reporting a healthy status.`,
	"privategateway.form.inactivetitle": "Inactive Gateways",
	"privategateway.form.inactivesubtitle": `These gateways are inactive and not in use.
		To add them to the pool of active gateways, click the "Activate" button.`,
	"privategateway.deactivate.disabled.tooltip": `You must have at least one gateway active. Select the cloud gateway above if you wish to
		stop using this private gateway.`,
	"clockskew.text.warning": "Clock Skew: [[clockSkew]]",
	"clockskew.text.bad": "Clock Skew: [[clockSkew]]",
	"clockskew.tooltip": `Clock skew can cause clients to fail to connect. Check that VMWare Tools is running for the gateway and that the
		VM host's clock is correct. If clock skew persists, try restarting the private gateway.`,
	"gateway.has.overlapping.ip.port.message": `The gateway you are trying to activate conflicts
	 with an existing Gateway's public IP address or port(s).
	 To fix this click the 'Continue' button. Click 'Cancel' to cancel activation of this Gateway.`,
	"gateway.has.overlapping.ip.port.title": "Gateway conflicts with an Active Gateway",
	"error.form.has.overlapping-ip-ports.short": `Gateway IP/Port conflict.`,
	"error.form.has.overlapping-ip-ports": `The gateway you are trying to activate conflicts with an existing Gateway's Public IP address
	 or port(s).`,
	"warning.form.has.overlapping-ip-ports.short": `Gateway IP/Port overlap`,
	"warning.form.has.overlapping-ip-ports": `The Internet IP/Ports overlap with another gateway.
		If you have configured port forwards in your router, you'll need unique ports for each gateway.
		For most networks you can ignore this warning and SDP Session Traversal will allow users to connect.
		Read more in the SDP FAQ.`,
	"sdp.session.idle.logged.out": "You have been logged out due to inactivity.",
	"sdp.session.idle.title": "Your session is about to expire",
	"sdp.session.idle.message": "For security reasons, your session will expire shortly.",
	"sdp.session.idle.button": "Stay Logged In",
	"sdp.user.wizard.edit.enabled.message": "Enable user",
	"error.message.login.disabled": `Your account has been disabled.
		Please contact your System Administrator if you believe this is in error.`,
	"error.message.login.invalidMfaCode": "Please try again. The MFA code you entered is invalid.",
	"user.disabled.tooltip": "This user is currently disabled. Click the edit icon to re-enable.",
	"home.area.help.description": " explains how to use the Example Application to get more familiar with our SDP Technology.",
	"home.link.help": "SafeConnect SDP Demo/Deployment Guide",
	"wizard-help-demo-link": "Demo Help Guide",
	"user.edit.admin.disabled": `Disabled users will not have access to the administrative portal.`,
	"dashboard.groups": "Groups",
	"sdp.label.saml-alias": "SAML Groups",
	"saml-alias.table.label": "Display Name",
	"saml-alias.table.saml-group": "SAML Group",
	"saml-alias.table.groups": "SAML Groups",
	"saml-alias.table.provider": "Provider",
	"saml-aliases.page.title": "SAML Groups",
	"saml-aliases.page.info": `Configure SAML Groups from your Identity Provider.`,
	"saml-alias.delete.dialog.title": "Delete SAML Group",
	"saml-alias.delete.dialog.message": "Are you sure you want to delete the SAML Group \"[[aliasLabel]]\"?",
	"saml-alias.delete.dialog.inUse.message": `<br><br>This SAML Group is used in at least one policy,
		deleting it will remove it from all policies.`,
	"saml-alias.update.success": "'[[label]]' SAML Group has been updated.",
	"saml-alias.add.success": "'[[label]]' SAML Group has been created.",
	"saml-alias.delete.success": "'[[label]]' SAML Group has been deleted.",
	"saml-alias.wizard.edit.title.update": "Update SAML Group",
	"saml-alias.wizard.edit.title.create": "Create SAML Group",
	"saml-alias.wizard.edit.description.create": "Add a SAML Group entry",
	"saml-alias.wizard.edit.description.update": "Update a SAML Group entry",
	"saml-alias.wizard.provider.message": "Select your IDP",
	"saml-alias.wizard.id.message": "Enter your IDP ID",
	"saml-alias.form.label.saml-group": "SAML Group",
	"saml-alias.wizard.alias.message": "Enter your Alias for your SAML Group",
	"saml-alias.form.label.alias": "Display Name (Optional)",
	"saml.delete.idp.dialog.message.has-alias": "<br><br>This Identity Provider has associated SAML Groups. Those will be deleted as well.",
	"saml-alias.no.idp-before": "First ",
	"saml-alias.no.idp-link": "set up an Identity Provider",
	"saml-alias.no.idp-after": " to begin adding SAML Groups.",
	"error.saml-alias.saml-group.duplicate": "SAML Group '[[group]]' is already defined for IDP '[[idp]]'.",
	"error.saml-alias.saml-label.duplicate": "The Display Name '[[displayName]]' is already defined.",
	"error.message.saml-group.max-length": "Field must be 256 characters or less.",
	"error.message.saml-group.pattern": "Field may only contain letters, digits, or the following symbols: \"-\", \"_\", \",\", \".\", \"=\".",
	"error.message.policy.application.required": "Application is required.",
	"policy.wizard.name.selector.message": "Application is required.",
	"policy.wizard.edit.select-list": "Users/SAML Groups",
	"policy.wizard.edit.display-list": "Selected Users/SAML Groups",
	"policy.wizard.groupSelect.title": `Create an Identity Access Policy for \"[[applicationName]]\"`,
	"policy.wizard.groupSelect.info": "This policy allows access to an application based on users and SAML groups.",
	"policy.wizard.add.samlAlias.text": "Add SAML Group",
	"policy.wizard.selectedAccessData.empty": "None selected",
	"policy.add.success": "Access policy created for '[[name]]'.",
	"policy.update.success": "Access policy updated for '[[name]]'.",
	"policy.delete.success": "Access policy deleted for '[[name]]'.",
	"policy.no.resources": "All of your applications already have policies. Use the pencil icon(s) below to edit an existing policy.",
	"applications.add.disabled": "Application management is temporarily disabled while we roll out new features. Please check back shortly.",
	"users.add.disabled": "User management is temporarily disabled while we roll out new features. Please check back shortly.",
	"policies.add.disabled": "Policy management is temporarily disabled while we roll out new features. Please check back shortly.",
	"sessions.disconnect.dialog.title": "Disconnect User",
	"sessions.disconnect.dialog.message.cognito": "Are you sure you want to disconnect user: \"[[userName]]\"?",
	"sessions.disconnect.dialog.message.saml": "Are you sure you want to disconnect sessions for: \"[[userName]]\"? Note that if the user is not disabled in the SAML IdP, the user may be allowed to reconnect.",
	"sessions.disconnect.button.label": "Disconnect",
	"sessions.disconnect.success.disabled": "All active sessions for \"[[userName]]\" are being disconnected, and they have been disabled. Check back shortly.",
	"sessions.disconnect.success.all": "All active sessions for \"[[userName]]\" are being disconnected. Check back shortly.",
	"sessions.disconnect.success.single": "This session for \"[[userName]]\" is being disconnected. Check back shortly.",
	"sessions.disconnect.tooltip.saml": "SAML users can't be disabled. See your SAML IdP to disable \"[[userName]]\". If you don't disable future logins, this user might be able to reconnect.",
	"sessions.disconnect.tooltip.primary": "The account owner can't be disabled.",
	"sessions.disconnect.tooltip.all": "When the user is being disabled all active sessions are automatically disconnected.",
	"sessions.disconnect.tooltip.button": "Disconnect this session",
	"settings.description": `Manage your user settings. Change your name, setup Multi Factor Authentication, reset your password,
	or enable/disable the wizard.`,
	"name-change.title": "Change Name",
	"name-change.description": "Update your name",
	"error.message.lastName.required": "Last Name is required",
	"error.message.firstName.required": "First Name is required",
	"name-change.success": "Your name has been updated"
};
